import { Grid, Paper, Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import SubmitButton from "../../components/button/SubmitButton";
import SearchBar from "../../components/inputs/SearchBar";
import DataTable from "../../components/tables/DataTable";
import ClickButton from "../../components/button/ClickButton";
import { USER_ROLES } from "../../utils/constants";

const HearNUListUI = ({
  filters,
  setFilters,
  loading,
  list,
  onCreateBtnClick,
  columns,
  countLoading,
  count,
  setCountStatus,
  countStatus,
}) => {
  const { user } = useSelector((state) => state);
  const modifiedCount = count?.map((status) => ({
    ...status,
    label: user?.data?.role === USER_ROLES?.DISTRIBUTOR && status.label === "Order Received" 
      ? "Order Placed" 
      : status.label
  }));
  
  return (
    <Box p={3}>
      <Paper elevation={2} sx={{ width: "100%", p: 3 }}>
        <Box
          mb={3}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography variant="h3" sx={{ mb: { xs: 2, md: 0 } }}>
            Custom HearNU
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <SearchBar
              placeholder="Search Patient Name"
              value={filters?.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            />
            {[USER_ROLES?.DISTRIBUTOR].includes(user?.data?.role) && (
              <Box sx={{ mt: { xs: 2, sm: 0 }, ml: { sm: 2 } }}>
                <SubmitButton onClick={onCreateBtnClick} title="Add Patient" />
              </Box>
            )}
          </Box>
        </Box>

        {user?.data?.role !== USER_ROLES?.ASSEMBLY && (
          <>
            {countLoading ? (
              <Grid container spacing={2} sx={{ mb: 3, justifyContent: "center" }}>
                {[0, 1, 2, 3].map((row) => (
                  <Grid item xs={12} sm={6} md={3} key={row}>
                    <Skeleton
                      variant="rectangular"
                      height={120}
                      sx={{ borderRadius: 2, boxShadow: 2 }}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid container spacing={2} sx={{ justifyContent: "center", mb: 3 }}>
              {modifiedCount?.map((status) => (
                <Grid key={status.status} item xs={6} sm={4} md={2}>
                  <ClickButton
                    active={status?.status === countStatus}
                    title={status?.count.toString()}
                    subTitle={status?.label}
                    onClick={() => setCountStatus(status?.status)}
                  />
                </Grid>
              ))}
            </Grid>
            )}
          </>
        )}

        <DataTable
          columns={columns}
          rows={list?.result ? list?.result : []}
          count={list?.total ?? 0}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
        />
      </Paper>
    </Box>
  );
};

export default memo(HearNUListUI);
